module.exports = __webpack_public_path__ + "img/dis.78613ad1.png";